<template>
  <div class="right">
    <div class="spen">
      <span>{{ $t('common.My_tracks') }}</span>
      <div class="guanli">
        <!-- <img src="../../../assets/order/shanchu.png" alt="" /> -->
        <!-- <span>批量管理</span> -->
      </div>
    </div>
    <Loading v-if="isLoading" />
    <div v-else>
      <div class="tishi" v-if="list == ''">{{ tishi }}</div>
      <div class="neirong">
        <!-- <div class="time">
        <div class="nowtime1">12.3</div>
        <div class="nowtime2">今天</div>
        <div class="jian1">4件宝贝</div>
        <div class="jiange1"></div>
        <div class="yestime1">12.2</div>
        <div class="yestime1">昨天</div>
        <div class="jian2">8件宝贝</div>
        <div class="jiange2"></div>
      </div> -->
        <div class="changgou">
          <div class="list" v-for="(item, index) in list" :key="index">
            <div class="list_T" @mouseover="over(index)" @mouseout="out(index)">
              <Uimage :src="item.spuImg" alt="" />
              <div v-show="activeIndex === index">
                <div class="yigou1" @click="delattention(item.collectSpuId)">
                  {{ $t('common.delete') }}
                </div>
              </div>
            </div>
            <div class="list_B">
              <div class="title" @click="detail(item.storeId, item.spuId)">
                {{ item.name }}
              </div>
              <div class="price">
                <div class="price_L">
                  ￥<span class="spen">{{ item.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fenye" v-if="list != ''">
      <!-- <el-pagination
        background
        layout="prev, pager, next"
        :total="totalNum"
        @current-change="pagechange"
        :current-page.sync="currentPage"
        v-if="totalNum != 0"
      ></el-pagination> -->
      <el-pagination
        @current-change="pagechange"
        :current-page="page.current"
        style="text-align: right;margin-top: 20px"
        background
        :total="page.total"
        :page-size="page.size"
        layout="prev, pager, next, jumper, ->, total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { post, get } from '@/utils/request';
export default {
  data() {
    return {
      list: [],
      activeIndex: -1,
      currentPage: 1,
      totalNum: 1,
      isLoading: true,
      tishi: this.$t('common.Its_empty'),
      page: {
        total: 1,
        size: 10,
        current: 1,
      },
    };
  },
  created() {
    this.getorder();
  },
  methods: {
    detail(storeId, spuId) {
       const { href } = this.$router.resolve({
        name: 'detail',
        params: {
          //店铺id
          storeId: storeId,
          //商品id
          spu: spuId,
        },
      });
      window.open(href, '_self');
    },
    pagechange(p) {
      this.page.current = p;
      get(
        'api/collectspu/selCollectSpuList?pageNum=' + p + '&pageSize=10'
      ).then((res) => {
        this.list = res.data.data;
      });
    },
    getorder() {
      get('api/collectspu/selCollectSpuList?pageNum=1&pageSize=10').then(
        (res) => {
          this.list = res.data.data.list;
          this.page.total = res.data.data.total;
          this.isLoading = false;
        }
      );
    },
    over(index) {
      this.activeIndex = this.activeIndex == index ? -1 : index;
    },
    out(index) {
      this.activeIndex = this.activeIndex == index ? -1 : index;
    },
    delattention(e) {
      this.$confirm(this.$t('message.Whether_to_unfollow'), this.$t('common.Confirmation'), {
        confirmButtonText: this.$t('button.Confirm'),
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning',
      }).then(() => {
        // let len = this.list.length;
        // for (let i = 0; i < len; i++) {
        //   if (e == this.list[i].collectSpuId) {
        //     this.list.splice(i, 1);

        //   }
        // }
        get('api/collectspu/deleteshopcollectsup?collectSpuId=' + e + '').then(
          (res) => {
            this.getorder();
          }
        );
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tishi {
  width: 90%;
  text-align: center;
  margin-top: 150px;
  font-size: 24px;
  color: rgb(139, 135, 135);
}
.fenye {
  margin-top: 50px;
  margin-bottom: 20px;
}
.right {
  width: 1006px;
  padding-top: 34px;
  padding-left: 27px;
  background: #fff;
 
  .spen {
    font-size: 26px;
    font-weight: 600;
    color: #616161;
    display: flex;
    justify-content: space-between;
    .guanli {
      font-size: 14px;
      color: #666;
      font-weight: normal;
      display: flex;
      align-items: center;
      margin-right: 28px;
      img {
        width: 17px;
        height: 19px;
        margin-right: 5px;
      }
    }
  }
  .neirong {
    width: 975px;
    margin-top: 13px;
    .time {
      display: flex;
      height: 50px;
      width: 100%;
      align-items: center;
      .nowtime1 {
        font-size: 20px;
        color: #ff8f28;
      }
      .nowtime2 {
        font-size: 15px;
        color: #ff8f28;
        margin-left: 7px;
      }
      .jian1 {
        font-weight: 13px;
        color: #999;
        margin-left: 7px;
      }
      .jiange1 {
        width: 16px;
        height: 2px;
        background: #ccc;
        margin-left: 7px;
      }
      .yestime1 {
        font-size: 20px;
        color: #ff8f28;
        margin-left: 7px;
      }
      .yestime2 {
        font-size: 15px;
        color: #ff8f28;
        margin-left: 7px;
      }
      .jian2 {
        font-weight: 13px;
        color: #999;
        margin-left: 7px;
      }
      .jiange2 {
        flex: 1;
        height: 1px;
        background: #eee;
        margin-left: 7px;
      }
    }
    .changgou {
      width: 975px;
      margin: 0px auto;
      padding-bottom: 50px;
      display: flex;
      flex-wrap: wrap;

      .list {
        width: 234px;
        height: 404px;
        border: 2px solid #f0f5f1;
        margin-top: 10px;
        margin-left: 5px;
        position: relative;

        .yigou1 {
          width: 115px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: #9ba2a8;
          cursor: pointer;
          position: absolute;
          top: 0;
          right: 0;
          color: #fff;
          font-size: 12px;
        }
        .list_T {
          width: 234px;
          height: 279px;
          position: relative;

          .yigou1 {
            width: 115px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #9ba2a8;
            cursor: pointer;
            position: absolute;
            top: 0;
            right: 0;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
        .list_B {
          padding: 0 15px;
          .title {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-top: 20px;
            font-size: 14px;
            color: #333;
            cursor: pointer;
          }
          .price {
            height: 25px;
            line-height: 25px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            .price_L {
              color: #e88021;
              font-size: 12px;
              display: flex;
              .spen {
                font-size: 14px;
                color: #e88021;
              }
            }
          }
        }
      }
    }
  }
}
</style>
